import { render, staticRenderFns } from "./ProfilSelector.vue?vue&type=template&id=62b287d7"
import script from "./ProfilSelector.vue?vue&type=script&lang=js"
export * from "./ProfilSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports